module.exports = __webpack_public_path__ + "img/ic-drop-yellow-copy-46.5c2ab84d.svg";